import React from "react";
import "./styles.css";
import Icon from "../Icon";

const Button = ({
  variant = "",
  children,
  handleClick = () => {},
  className = "",
  id = "",
  disabled,
  active = false,
  loading,
  extensions = "",
  icon = "",
}) => {
  const iconElement = icon ? <Icon name={icon} aria-hidden="true" /> : null;

  if (variant === "input") {
    return (
      <label className={`btn ${className}`}>
        {children}
        <input onChange={handleClick} name="pdb" accept={extensions} type="file" hidden />
      </label>
    );
  } else {
    return (
      <button
        id={id}
        className={`btn ${className} ${variant} ${active ? "active" : ""} ${icon ? "icon" : ""} ${loading ? "loading" : ""} ${icon && children ? "icon-with-text" : ""}`}
        disabled={disabled || loading}
        onClick={handleClick}
      >
        {loading ? (
          "Loading..."
        ) : (
          <>
            {iconElement}
            {children}
          </>
        )}
      </button>
    );
  }
};
export default Button;
